<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 344.4 326" style="enable-background:new 0 0 344.4 326;" xml:space="preserve">
    <g>
      <defs>
        <rect id="s6_1_" x="7.2" y="143.4" width="142.7" height="142.7"/>
      </defs>
      <clipPath id="s6_2_">
        <use xlink:href="#s6_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            
              <rect id="s6_3_" x="24.1" y="159.7" transform="matrix(0.8755 -0.4832 0.4832 0.8755 -93.7626 64.7036)" width="109.1" height="109.1"/>
          </defs>
          <clipPath id="s6_4_">
            <use xlink:href="#s6_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <g>
              <defs>
                <path id="s6_5_" d="M12.4,188.6l79.8-44c4.3-2.4,9.8-0.8,12.2,3.5l44,79.8c2.4,4.3,0.8,9.8-3.5,12.2l-79.8,44
                  c-4.3,2.4-9.8,0.8-12.2-3.5l-44-79.8C6.5,196.4,8.1,191,12.4,188.6z"/>
              </defs>
              <clipPath id="s6_6_">
                <use xlink:href="#s6_5_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st2">
                <path class="st3" d="M4.5,192.9l95.6-52.7l52.7,95.6l-95.6,52.7L4.5,192.9z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_7_" x="189.9" y="150" width="145.3" height="145.3"/>
      </defs>
      <clipPath id="s6_8_">
        <use xlink:href="#s6_7_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st4">
        <g>
          <defs>
            
              <rect id="s6_9_" x="207.9" y="168.4" transform="matrix(0.5944 -0.8042 0.8042 0.5944 -72.5461 301.5003)" width="109.4" height="108.5"/>
          </defs>
          <clipPath id="s6_10_">
            <use xlink:href="#s6_9_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st5">
            <g>
              <defs>
                <path id="s6_11_" d="M191.8,227.2l54.2-73.3c3-4,8.6-4.8,12.6-1.9l72.8,53.8c4,3,4.8,8.6,1.9,12.6l-54.2,73.3
                  c-3,4-8.6,4.8-12.6,1.9l-72.8-53.8C189.7,236.8,188.9,231.2,191.8,227.2z"/>
              </defs>
              <clipPath id="s6_12_">
                <use xlink:href="#s6_11_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st6">
                <path class="st3" d="M186.5,234.4l64.8-87.6l87.3,64.5l-64.8,87.6L186.5,234.4z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_13_" x="113.9" y="212.7" width="113.3" height="113.3"/>
      </defs>
      <clipPath id="s6_14_">
        <use xlink:href="#s6_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            
              <rect id="s6_15_" x="116.1" y="214.9" transform="matrix(3.150407e-02 -0.9995 0.9995 3.150407e-02 -104.2986 431.4664)" width="108.9" height="109.3"/>
          </defs>
          <clipPath id="s6_16_">
            <use xlink:href="#s6_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <g>
              <defs>
                <path id="s6_17_" d="M126.6,213.7l91.1,2.9c5,0.2,8.9,4.3,8.7,9.3l-2.9,90.8c-0.2,5-4.3,8.9-9.3,8.7l-91.1-2.9
                  c-5-0.2-8.9-4.3-8.7-9.3l2.9-90.8C117.5,217.5,121.6,213.6,126.6,213.7z"/>
              </defs>
              <clipPath id="s6_18_">
                <use xlink:href="#s6_17_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st9">
                <path class="st3" d="M117.6,213.4l109.2,3.4l-3.4,108.8l-109.2-3.4L117.6,213.4z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_19_" x="115.8" width="109.6" height="109.1"/>
      </defs>
      <clipPath id="s6_20_">
        <use xlink:href="#s6_19_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st10">
        <g>
          <defs>
            <path id="s6_21_" d="M115.8,100.1V9c0-5,4-9,9-9h91.3c5,0,9,4,9,9v91.1c0,5-4,9-9,9h-91.3
              C119.8,109.1,115.8,105.1,115.8,100.1z"/>
          </defs>
          <clipPath id="s6_22_">
            <use xlink:href="#s6_21_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st11">
            <path class="st3" d="M115.8,109.1V0h109.1v109.1H115.8z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_23_" x="201.9" y="43.4" width="140" height="140"/>
      </defs>
      <clipPath id="s6_24_">
        <use xlink:href="#s6_23_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st12">
        <g>
          <defs>
            
              <rect id="s6_25_" x="217.7" y="59.1" transform="matrix(0.9116 -0.411 0.411 0.9116 -22.6774 121.9436)" width="109.1" height="109.1"/>
          </defs>
          <clipPath id="s6_26_">
            <use xlink:href="#s6_25_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st13">
            <g>
              <defs>
                <path id="s6_27_" d="M208.3,82.7l83.1-37.5c4.5-2,9.9,0,11.9,4.5l37.5,83.1c2,4.5,0,9.9-4.5,11.9l-83.1,37.5
                  c-4.5,2-9.9,0-11.9-4.5l-37.5-83.1C201.7,90.1,203.8,84.7,208.3,82.7z"/>
              </defs>
              <clipPath id="s6_28_">
                <use xlink:href="#s6_27_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st14">
                <path class="st3" d="M200.1,86.4l99.5-44.9l44.9,99.5l-99.5,44.8L200.1,86.4z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_29_" x="111.8" y="97.4" width="129.8" height="129.8"/>
      </defs>
      <clipPath id="s6_30_">
        <use xlink:href="#s6_29_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st15">
        <g>
          <defs>
            <path id="s6_31_" d="M111.8,218.2V106.4c0-5,4-9,9-9h111.8c5,0,9,4,9,9v111.8c0,5-4,9-9,9H120.8
              C115.8,227.2,111.8,223.2,111.8,218.2z"/>
          </defs>
          <clipPath id="s6_32_">
            <use xlink:href="#s6_31_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st16">
            <path class="st3" d="M111.8,227.2V97.4h129.8v129.8H111.8z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_33_" x="1.9" y="43.4" width="141.3" height="141.3"/>
      </defs>
      <clipPath id="s6_34_">
        <use xlink:href="#s6_33_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st17">
        <g>
          <defs>
            
              <rect id="s6_35_" x="18.5" y="59" transform="matrix(0.4365 -0.8997 0.8997 0.4365 -61.1631 129.8804)" width="109.1" height="109.6"/>
          </defs>
          <clipPath id="s6_36_">
            <use xlink:href="#s6_35_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st18">
            <g>
              <defs>
                <path id="s6_37_" d="M3.9,130.9l39.8-82c2.2-4.5,7.6-6.3,12-4.2l82.1,39.8c4.5,2.2,6.3,7.6,4.2,12l-39.8,82
                  c-2.2,4.5-7.6,6.3-12,4.2L8.1,142.9C3.6,140.7,1.8,135.3,3.9,130.9z"/>
              </defs>
              <clipPath id="s6_38_">
                <use xlink:href="#s6_37_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st19">
                <path class="st3" d="M0,139l47.6-98.2l98.2,47.6l-47.6,98.2L0,139z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_39_" x="27.8" y="17.3" width="290" height="290"/>
      </defs>
      <clipPath id="s6_40_">
        <use xlink:href="#s6_39_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st20">
        <g>
          <defs>
            <circle id="s6_41_" cx="172.8" cy="162.3" r="145"/>
          </defs>
          <clipPath id="s6_42_">
            <use xlink:href="#s6_41_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st21">
            <path class="st22" d="M27.8,17.3h290v290h-290V17.3z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s6_43_" x="87.1" y="75.6" width="171.5" height="171.5"/>
      </defs>
      <clipPath id="s6_44_">
        <use xlink:href="#s6_43_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st23">
        <g>
          <defs>
            <path id="s6_45_" d="M172.8,75.6c-47.3,0-85.7,38.4-85.7,85.7s38.4,85.7,85.7,85.7c47.3,0,85.7-38.4,85.7-85.7
              S220.2,75.6,172.8,75.6z"/>
          </defs>
          <clipPath id="s6_46_">
            <use xlink:href="#s6_45_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st24">
            <path class="st3" d="M87.1,75.6h171.5v171.5H87.1V75.6z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'r4'
  }
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
</style>

<style scoped>
  .st0{clip-path:url(#s6_2_);}
  .st1{clip-path:url(#s6_4_);}
  .st2{clip-path:url(#s6_6_);}
  .st3{fill:#2C6EDF;}
  .st4{clip-path:url(#s6_8_);}
  .st5{clip-path:url(#s6_10_);}
  .st6{clip-path:url(#s6_12_);}
  .st7{clip-path:url(#s6_14_);}
  .st8{clip-path:url(#s6_16_);}
  .st9{clip-path:url(#s6_18_);}
  .st10{clip-path:url(#s6_20_);}
  .st11{clip-path:url(#s6_22_);}
  .st12{clip-path:url(#s6_24_);}
  .st13{clip-path:url(#s6_26_);}
  .st14{clip-path:url(#s6_28_);}
  .st15{clip-path:url(#s6_30_);}
  .st16{clip-path:url(#s6_32_);}
  .st17{clip-path:url(#s6_34_);}
  .st18{clip-path:url(#s6_36_);}
  .st19{clip-path:url(#s6_38_);}
  .st20{clip-path:url(#s6_40_);}
  .st21{clip-path:url(#s6_42_);}
  .st22{fill:#75A0F1;}
  .st23{clip-path:url(#s6_44_);}
  .st24{clip-path:url(#s6_46_);}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/r6.vue